import * as React from "react";
import * as Scrivito from "scrivito";

import cx from "classnames";

type BackgroundWrapperProps = {
  page: Scrivito.Obj;
  classNames?: string;
  children: React.ReactElement;
};

export const BackgroundWrapper = Scrivito.connect(
  ({ page, classNames, children }: BackgroundWrapperProps) => {
    const backgroundImage = page.get("backgroundImage") as Scrivito.Obj;

    return backgroundImage ? (
      <Scrivito.BackgroundImageTag
        className="background-image bg-gray-700"
        style={{
          background: {
            image: backgroundImage,
            position: "right",
            size: "contain",
          },
        }}
      >
        <div className={cx("container", classNames)}>{children}</div>
      </Scrivito.BackgroundImageTag>
    ) : (
      <div className={cx("container", classNames)}>{children}</div>
    );
  },
);
